import { Component, Prop, Event, EventEmitter, h, Host, State } from '@stencil/core';
import { white } from 'pn-design-assets/pn-assets/colors.js';

@Component({
  tag: 'pn-progress-indicator-step',
  styleUrl: 'pn-progress-indicator-step.scss',
})
export class PnProgressIndicatorStep {
  @State() activated: boolean;
  @State() done: boolean;

  /** Set by the parent component. Do not use manually. @hide true */
  @Prop() activeStep: number;
  /** Set by the parent component. Do not use manually. @hide true */
  @Prop() index: number;
  /** The step name. */
  @Prop() name: string;
  /** Set the step as checked, meaning a white check mark will appear. */
  @Prop() checked: boolean = false;
  /** Set by the parent component. Do not use manually. @hide true */
  @Prop() active?: 'yes' | 'no';

  @Event() setactivestep: EventEmitter<number>;
  setActiveStepHandler() {
    if (this.done || this.activated) {
      this.setactivestep.emit(this.index);
    }
  }

  componentWillLoad() {
    this.checkStatus();
  }

  componentDidUpdate() {
    this.checkStatus();
  }

  checkStatus() {
    if (!this.done) {
      this.done = this.checked || this.activeStep > this.index;
    }

    if (this.active === 'yes') {
      this.activated = true;
    } else if (this.active === 'no') {
      this.activated = false;
      this.done = false;
    } else if (!this.activated) {
      this.activated = this.activeStep >= this.index;
    }
  }

  getClassNames() {
    let className = 'pn-progress-indicator-step';
    if (this.done || this.checked) className += ' done';
    if (this.activated) className += ' activated';
    if (this.activeStep === this.index) className += ' active';
    return className;
  }

  render() {
    return (
      <Host class={this.getClassNames()} onClick={() => this.setActiveStepHandler()}>
        <div class="progress-line" />
        <div class="info-container">
          <slot />
          {this.name}
        </div>
        <div class="circle">
          {this.done || this.checked ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              enable-background="new 0 0 24 24"
              id="checkmark"
              version="1.0"
              viewBox="0 0 24 24"
            >
              <polyline
                class="checkmark-path"
                fill="none"
                points="20,6 9,17 4,12"
                stroke={white}
                stroke-miterlimit="10"
                stroke-width="3"
              />
            </svg>
          ) : (
            ''
          )}
        </div>
      </Host>
    );
  }
}
